export function isPlatinumProduct(metal: string, metalType?: string | null): boolean {
  return metal === 'Platinum' || metalType === 'Platinum';
}

function extractPlatinumPurity(
  goldPurity: string | null | undefined,
  metalType: string | null | undefined,
  shortDesc?: string | null
): string {
  const sources = [goldPurity, metalType, shortDesc]
    .filter((value): value is string => Boolean(value && value.trim()))
    .join(' ');

  const ptMatch = sources.match(/pt\s*(\d{3})/i);
  if (ptMatch) return ptMatch[1];

  const numericMatch = sources.match(/\b(\d{3})\b/);
  if (numericMatch) return numericMatch[1];

  return '950';
}

function formatPlatinumTypeValue(
  goldPurity: string | null | undefined,
  metalType: string | null | undefined,
  shortDesc?: string | null
): string {
  const purity = extractPlatinumPurity(goldPurity, metalType, shortDesc);
  return `${purity}Kt Platinum`;
}

/** Resolves the Metal Details "Type" value (e.g. "950Kt Platinum", "18KT Gold"). */
export function getMetalTypeDetailValue(
  goldPurity: string | null | undefined,
  metal: string,
  metalType: string,
  shortDesc?: string | null,
  goldDisplayName = 'Gold'
): string | null {
  if (isPlatinumProduct(metal, metalType)) {
    return formatPlatinumTypeValue(goldPurity, metalType, shortDesc);
  }

  const purity = goldPurity?.trim();
  if (!purity) return null;

  const displayMetal = goldDisplayName === 'Gold' ? metalType : goldDisplayName;
  return `${purity} ${displayMetal}`;
}

export function getMetalWeightLabel(metal: string, metalType: string): string {
  if (isPlatinumProduct(metal, metalType)) {
    return 'Platinum Weight';
  }

  return `${metalType} Weight`;
}
